export enum EGroupActionType {
  Sms = "sms",
  Email = "email",
}

export enum EGroupActionModalStep {
  SelectAction = "SELECT_ACTION",
  AddContent = "ADD_CONTENT",
  Finished = "FINISHED",
}
